module.exports = __webpack_public_path__ + "static/media/ss.e2c2512f.svg";